export default [
  {
    path: "cart",
    name: "cart.page",
    component: () => import("@pages/cart/Cart"),
  },
];
